import { Button, Form, Input, message } from "antd";
import { useForm } from "antd/lib/form/Form";
import { useCallback, useState } from "react";
import { SysRoleService } from "../../../../../services/config/qltl-config/sysRole";

interface FormValues {
  name: string;
  description: string;
}

interface RoleFormProps {
  onClose: () => void;
  refresh: () => Promise<void>;
}

const RoleForm = ({ onClose, refresh }: RoleFormProps) => {
  const [form] = useForm<FormValues>();
  const [isAddLoading, setIsAddLoading] = useState(false);

  const handleSubmit = useCallback(
    async (values: FormValues) => {
      setIsAddLoading(true);

      try {
        await SysRoleService.createRole(values);
        await refresh();

        onClose();
        form.resetFields();
        message.success("Thêm vai trò thành công");
      } catch (error) {
        message.error((error as Error)?.message || "Thêm vai trò thất bại");
      } finally {
        setIsAddLoading(false);
      }
    },
    [form, onClose, refresh],
  );

  return (
    <Form form={form} layout="vertical" onFinish={handleSubmit}>
      <Form.Item label="Tên vai trò" name="name" rules={[{ required: true, message: "Vui lòng nhập tên vai trò" }]}>
        <Input placeholder="Nhập tên vai trò" />
      </Form.Item>
      <Form.Item label="Mô tả" name="description">
        <Input.TextArea placeholder="Nhập mô tả" rows={4} />
      </Form.Item>
      <div className="flex justify-end gap-2">
        <Button disabled={isAddLoading} onClick={onClose}>
          Hủy bỏ
        </Button>
        <Button htmlType="submit" type="primary" loading={isAddLoading}>
          Thêm mới
        </Button>
      </div>
    </Form>
  );
};

export default RoleForm;
